import React, {Component, Fragment} from "react";
import CardBase from "../../../../ui/cards/CardBase";
import {Image} from "react-bootstrap";
import {Link} from "react-router-dom";
import classNames from 'classnames';

import Divider from "../../../../ui/Divider";
import '../../../../../assets/sass/pages/matches-and-events/cards/result-card.scss';
import Icon, {icnWatchlistDefault} from "../../../../ui/Icon";
import MatchAndEventMatchReport from "../../MatchAndEventMatchReport";

class ResultCard extends CardBase {
    renderBody = () => {
        return (
            <Fragment>
                {this.renderTeams()}
                {this.renderGoals()}
                {this.renderAssists()}
            </Fragment>
        );
    };


    renderFooter = () => {
        const viewMoreText = 'View Full Match Stats and Videos';
        const {matchId} = this.props;

        return (
            <div className="view-more"><Link to={`${MatchAndEventMatchReport.Route}/${matchId}`}> {viewMoreText} </Link></div>
        );
    };

    /**
     * renders teams section.
     * @returns {React.Node} The teams section.
     */
    renderTeams = () => {
        const {team1, team2} = this.props;
        return <ResultCard.Teams team1={team1} team2={team2}/>;
    };

    /**
     * renders goals section.
     * @returns {React.Node} The goals section.
     */
    renderGoals = () => {
        const {team1, team2} = this.props;
        return <ResultCard.Goals team1={team1} team2={team2}/>
    };

    /**
     * renders assists section.
     * @returns {React.Node} The assists section.
     */
    renderAssists = () => {
        const {team1, team2} = this.props;
        return <ResultCard.Assists team1={team1} team2={team2}/>
    };

    /**
     * Returns the classes of the card component.
     * @returns {string} The card classes.
     */
    cardClasses = () => 'result-card';

    /**
     * Returns the classes of the card header component.
     * @returns {string} The card header classes.
     */
    cardHeaderClasses = () => `${this.cardClasses()}--header`;

    /**
     * Returns the classes of the card body component.
     * @returns {string} The card body classes.
     */
    cardBodyClasses = () => `${this.cardClasses()}--body`;

    /**
     * Returns the classes of the card footer component.
     * @returns {string} The card footer classes.
     */
    cardFooterClasses = () => `${this.cardClasses()}--footer`;
}

ResultCard.Teams = props => {
    const {team1, team2} = props;
    const {name: team1Name, logo: team1Logo, score: team1Score} = team1;
    const {name: team2Name, logo: team2Logo, score: team2Score} = team2;
    console.log(team1, team2);

    return (
        <div className="teams">
            <div className="team left">
                <Image className="team--logo" src={team1Logo}/>
                <div className="team--name"> {team1Name}</div>
                <div className="team--score"> {team1Score}</div>
            </div>
            <div className="teams--splitter"> |</div>
            <div className="team right">
                <div className="team--score"> {team2Score}</div>
                <div className="team--name"> {team2Name}</div>
                <Image className="team--logo" src={team2Logo}/>
            </div>
        </div>
    )
};
ResultCard.Goals = props => {
    const goalsText = 'Goals';

    const {team1, team2} = props;
    const {goals: team1Goals} = team1;
    const {goals: team2Goals} = team2;

    return (
        <div className="goals">
            <div className="team left">
                <div className="goals--title">{goalsText}</div>
                <div className="goals--container">
                    <ResultCard.GoalsItem goals={team1Goals}/>
                </div>
            </div>
            <Divider show={true} direction="vertical"/>
            <div className="team right">
                <div className="goals--title">{goalsText}</div>
                <div className="goals--container">
                    <ResultCard.GoalsItem goals={team2Goals}/>
                </div>
            </div>
        </div>
    );
};

ResultCard.Assists = props => {
    const assistsText = 'Assists';

    const {team1, team2} = props;
    const {assists: team1Assists} = team1;
    const {assists: team2Assists} = team2;

    return (
        <div className="assists">
            <div className="team left">
                <div className="assists--title">{assistsText}</div>
                <div className="assists--container">
                    <ResultCard.AssistsItem assists={team1Assists}/>
                </div>
            </div>
            <Divider show={true} direction="vertical"/>
            <div className="team right">
                <div className="assists--title">{assistsText}</div>
                <div className="assists--container">
                    <ResultCard.AssistsItem assists={team2Assists}/>
                </div>
            </div>
        </div>
    );
};


ResultCard.GoalItem = props => {
    const {player, time} = props;
    const timeFormat = `${time}'`;

    return (
        <div className="goal">
            <ResultCard.PlayerAvatar {...player}/>
            <div className="goal--time"> {timeFormat} </div>
        </div>
    );
};

ResultCard.GoalsItem = props => {
    const {goals} = props;
    const noGoalsScoredText = 'No Goal Scored';

    if (goals.length) {
        return goals.map((goal, index) => <ResultCard.GoalItem key={index} {...goal}/>)
    } else {
        return (
            <span className="no-goals"> {noGoalsScoredText} </span>
        );
    }
};

ResultCard.AssistsItem = props => {
    const {assists} = props;
    const noAssistsScoredText = 'No Assists Scored';

    if (assists.length) {
        return assists.map((assist, index) => <ResultCard.PlayerAvatar key={index} {...assist.player}/>)
    } else {
        return (
            <span className="no-assists"> {noAssistsScoredText} </span>
        );
    }
};

ResultCard.PlayerAvatar = props => {
    const {avatar, card, sniper} = props;
    return (
        <div className="avatar--container">
            <Image className="avatar" src={avatar} roundedCircle/>
            {card && <div className={classNames("avatar--card", card)}/>}
            {sniper && <Icon className="avatar--sniper" svg={icnWatchlistDefault}/>}
        </div>
    );
};

export default ResultCard;
